import CryptoJS from "crypto-js";

const SECRET_KEY = "screenit-web-v2";

export const encryptUrl = (url: string) => {
  return CryptoJS.AES.encrypt(url, SECRET_KEY).toString();
};

export const decryptUrl = (encryptedUrl: string) => {
  const bytes = CryptoJS.AES.decrypt(encryptedUrl, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};
